
<footer class="page-footer font-small custom-bg-color">
  <div class="footer-copyright text-center py-3 custom-footer">© {{currentYear}} Fundo Garantidor de Créditos - FGC. Todos os direitos reservados.
      <a href="https://www.fgc.org.br/"> fgc.org.br</a>
  </div>
</footer>
